import { ENDPOINT_ATTACHMENT } from '../config'
import type { DeleteAttachmentResInterface } from '../types'
import type { AxiosResponse } from 'axios'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Delete an attachment (soft delete)
 */
const deleteAttachment = async (
  workspaceId: string,
  attachmentId: string,
): Promise<DeleteAttachmentResInterface> => {
  const endpoint = ENDPOINT_ATTACHMENT(workspaceId, attachmentId)

  const response: AxiosResponse<DeleteAttachmentResInterface> =
    await AuthAxios.delete(endpoint)

  return response.data
}

export default deleteAttachment
